var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import InputField from "@frameworks/shared-library/components/inputField";
import RadioButton from "@frameworks/shared-library/components/RadioButton/RadioButton";
import { Form } from "react-bootstrap";
import Select from "react-select";
import GenericDatePicker from "@frameworks/shared-library/components/GenericDatePicker/GenericDatePicker";
import SelectDropdownSearch from "./SelectDropdownSearch";
export var EAnswerInputType;
(function (EAnswerInputType) {
    EAnswerInputType["CHECKBOX"] = "CHECKBOX";
    EAnswerInputType["RADIO"] = "RADIO";
    EAnswerInputType["SELECT"] = "SELECT";
    EAnswerInputType["DATE"] = "DATE";
    EAnswerInputType["BLANK_INPUT"] = "BLANK_INPUT";
    EAnswerInputType["DROPDOWN_SEARCH"] = "DROPDOWN_SEARCH";
})(EAnswerInputType || (EAnswerInputType = {}));
export var generateBlankInput = function (data) {
    var _a;
    return (React.createElement("div", { className: "".concat(data.removeExistingClass ? "" : "w-100", " ").concat((_a = data.optionClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(InputField, __assign({}, data.props, { inputLabel: data.optionLabel, showBothPlaceholderAndLabel: true }))));
};
export var generateCheckbox = function (data) {
    // let value;
    // if (data.checkboxOptions.isSingle) {
    //   value = data?.optionValue as string | number;
    // } else {
    //   value = (data.optionValue as string[])?.filter(
    //     (item: string) => item === data.checkboxOptions.value
    //   )[0];
    // }
    var _a;
    return (React.createElement("div", { className: "".concat(data.removeExistingClass ? "" : "d-flex align-items-center gap-2", " ").concat((_a = data.optionClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(Form.Check, __assign({ type: "checkbox" }, data.props))));
};
export function generateSelect(data) {
    var _a;
    return (React.createElement("div", { className: "".concat(data.removeExistingClass
            ? ""
            : "d-flex flex-column gap-2 flex-grow-1 select-container", " ").concat((_a = data.optionClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement("span", { className: "profiler-inputs-placeholder " }, data.optionLabel),
        React.createElement(Select, __assign({}, data.props))));
}
export var generateRadioButton = function (data) {
    var _a, _b;
    return (React.createElement("div", { className: "".concat(data.removeExistingClass ? "" : "d-flex align-items-center gap-2", " ").concat((_a = data.optionClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement("span", { className: "DMSanN_14_400 " }, data.props.label), (_b = data.props.radioButtonList) === null || _b === void 0 ? void 0 :
        _b.map(function (radio, idx) { return (React.createElement(RadioButton, __assign({}, data.props, { list: radio, key: idx }))); })));
};
export var generateDatePicker = function (data) {
    var _a;
    return (React.createElement("div", { className: "".concat(data.removeExistingClass ? "" : "d-flex gap-2", " ").concat((_a = data.optionClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(GenericDatePicker, __assign({}, data.props, { label: data.optionLabel }))));
};
export var generateSelectDropdownSearch = function (data) {
    return (React.createElement("div", { className: " d-flex gap-2 flex-column" },
        React.createElement("span", { className: "DMSanN_16_400" }, data.optionLabel),
        React.createElement(SelectDropdownSearch, __assign({}, data.props))));
};
function FormComponentGenerator(props) {
    switch (props.optionType) {
        case EAnswerInputType.BLANK_INPUT:
            return generateBlankInput(props);
        case EAnswerInputType.RADIO:
            return generateRadioButton(props);
        case EAnswerInputType.DATE:
            return generateDatePicker(props);
        case EAnswerInputType.SELECT:
            return generateSelect(props);
        case EAnswerInputType.CHECKBOX:
            return generateCheckbox(props);
        case EAnswerInputType.DROPDOWN_SEARCH:
            return generateSelectDropdownSearch(props);
    }
}
export default FormComponentGenerator;
